export function deriveSource (row) {
  if (!row) return 'default'
  if (row.user) return 'user'
  if (row.group) return 'group'
  if (row.station) return 'station'
  return 'default'
}



// WEBPACK FOOTER //
// ./src/components/dashboard/stations/station/Pricing/deriveSource.js